import { h, render } from 'preact';
import ProductCard from '../utils/product-card';
import { Swiper, SwiperSlide } from 'swiper/react';
import { Navigation } from 'swiper';
import IconArrowRightLargeShadow from 'utils/icon/icon-arrow-right-large-shadow.svg';
export default (element,data) => {
  const breakpoints = {
    320: {
      slidesPerView: 2,
      spaceBetween: 10,
    },
    768: {
      slidesPerView: 3,
      spaceBetween: 20,
    },
    1024: {
      slidesPerView: 4,
      spaceBetween: 20,
    },
  };

  const renderProdutsPanel = () =>{
   return <div>
        {data.sectionTitle && <div class="sub-h3 lg:pb-4 pb-2.5">{data.sectionTitle}</div>}
        <div className='relative'>
          <div className="swiper-sample-prev  swiper-carousel-prev absolute text-white hover:text-supergoop-yellow rotate-180 z-10 top-2/4 -translate-y-2/4 left-0 cursor-pointer">
            <IconArrowRightLargeShadow />
          </div>
          <div className="swiper-sample-next swiper-carousel-next absolute text-white hover:text-supergoop-yellow z-10 top-2/4 -translate-y-2/4 right-0 cursor-pointer">
            <IconArrowRightLargeShadow />
          </div>
          <Swiper
              modules={[Navigation]}
              slidesPerView={4.3}
              allowTouchMove={true}
              spaceBetween={1}
              loop={false}
              breakpoints={breakpoints}
              navigation={{
                prevEl: '.swiper-carousel-prev',
                nextEl: '.swiper-carousel-next',
                disabledClass: 'hidden',
              }}
            >
              {data.blocks.map((block,index)=> <SwiperSlide className="h-auto" key={index}>
                <ProductCard useProductGiftForm product={block}/>
              </SwiperSlide>)}
          </Swiper>  
      </div>
    </div>
 
  }
  render(renderProdutsPanel(),element);
};
